<template>
  <div>
    <form
      class="form search-form js-search-form"
      @change="changeFilters"
      @submit.prevent="submitFilters"
    >
      <div
        v-if="config.showSearch"
        class="search-form__row search-form__row--term color-secondary"
      >
        <label
          for="search"
          class="sr-only"
        >
          Suchbegriff
        </label>

        <input
          id="search"
          v-model="settings.search"
          class="form__input search-form__term-input"
          placeholder="Suchbegriff"
          type="search"
        >

        <button class="button button--secondary search-form__submit">
          <svg
            viewBox="0 0 24 24"
            width="24"
            height="24"
            class="button__icon"
          >
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
          </svg>
          <span class="button__text sr-only">
            Suchen
          </span>
        </button>

        <p class="search-form__term-result-count">
          Anzahl Treffer: {{ hits }}
        </p>
      </div>

      <div
        :class="'search-form__row search-form__row--filter search-form__row--filter-' + config.source"
      >
        <label
          v-for="filtertype in config.filterTypes"
          :key="filtertype.id + '-label'"
          class="sr-only"
          :for="filtertype.id"
        >
          {{ filtertype.name }}
        </label>

        <select
          v-for="filterType in config.filterTypes"
          :id="filterType.id"
          :key="filterType.id"
          v-model.number="settings[filterType.id]"
          class="form__input form__input--primary form__input--solid form__input--select"
        >
          <option
            value=""
            disabled
            selected
          >
            {{ filterType.name }}
          </option>
          <option value="">
            {{ filterType.all }}
          </option>
          <option disabled>
            ┄┄┄┄┄
          </option>
          <option
            v-for="item in filters[filterType.listId]"
            :key="item.value"
            :value="item.value"
            :disabled="item.inactive"
          >
            {{ item.title }}
          </option>
        </select>

        <input
          type="submit"
          class="button button--secondary"
          value="GO!"
        >
      </div>
    </form>

    <p
      v-if="!config.showSearch"
      class="search-form__term-result-count"
    >
      Anzahl Treffer: {{ hits }}
    </p>

    <form
      v-if="config.showOrdering"
      class="search-form__sorting"
      @change="$emit('ordering-change', ordering)"
      @submit.prevent
    >
      <div class="search-form__row search-form__row--sorting">
        <p class="search-form__sorting-text">
          Sortieren nach:
        </p>

        <label class="form__radio form__radio--primary search-form__sorting-input">
          <input
            v-model="ordering"
            checked
            type="radio"
            value="-published"
          >
          <span class="form__radio-label">
            Aktualität
          </span>
        </label>

        <label class="form__radio form__radio--primary search-form__sorting-input">
          <input
            v-model="ordering"
            type="radio"
            value="-hits"
          >
          <span class="form__radio-label">
            Beliebtheit
          </span>
        </label>
      </div>
    </form>
  </div>
</template>

<script>
import getSearchConfig from '../functions/get-search-config'
import getUserSettings from '../functions/get-user-settings'

export default {
  name: 'CFilter',

  props: {
    // the raw filter options from the Api
    filters: {
      type: Object,
      required: true
    },
    // the ammount of hits in the search result
    hits: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      // the current filters set by the user
      settings: getUserSettings(this.$route, this.filters[getSearchConfig().slugToFilter.listId]),
      // the current ordering set by the user
      ordering: this.$route.query.ordering || '-published',
      config: getSearchConfig()
    }
  },

  methods: {
    getFilters () {
      const filters = {}

      for (const filter in this.settings) {
        if (this.settings[filter]) {
          filters[filter] = this.settings[filter]
        }
      }

      return filters
    },
    changeFilters () {
      this.$emit('filters-change', this.getFilters())
    },
    submitFilters () {
      this.$emit('filters-submit', this.getFilters())
    }
  }
}
</script>
